import { render, staticRenderFns } from "./VlNotAvailableNotification.vue?vue&type=template&id=27e8ae1a&scoped=true&"
import script from "./VlNotAvailableNotification.vue?vue&type=script&lang=js&"
export * from "./VlNotAvailableNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e8ae1a",
  null
  
)

export default component.exports